import Box from "@vapor/react-material/Box";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";

export const StatProgressBar = ({ label, value, count, total, color = "#1976d2" }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                    {label}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>
                    {value}% ({count}/{total})
                </Typography>
            </Box>
            <Box sx={{ 
                height: 8, 
                borderRadius: 5, 
                backgroundColor: '#f5f5f5', 
                overflow: 'hidden',
                position: 'relative'
            }}>
                <Box
                    sx={{
                        height: '100%',
                        width: `${value}%`,
                        backgroundColor: color,
                        borderRadius: 'inherit',
                        transition: 'width 0.3s ease'
                    }}
                />
            </Box>
        </Box>
    );
};

export const StatSection = ({ title, stats, colors }) => {
    // Protezione contro dati undefined/null
    if (!stats || Object.keys(stats).length === 0) {
        return (
            <Card sx={{ mb: 3, boxShadow: 1 }}>
                <CardContent sx={{ p: 3 }}>
                    <Typography variant="h6" sx={{ mb: 3, fontSize: '1.0rem', fontWeight: 'bold', color: '#1976d2' }}>
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                        Dati non disponibili
                    </Typography>
                </CardContent>
            </Card>
        );
    }
    
    return (
        <Card sx={{ mb: 3, boxShadow: 1 }}>
            <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ mb: 3, fontSize: '1.0rem', fontWeight: 'bold', color: '#1976d2' }}>
                    {title}
                </Typography>
                {Object.entries(stats).map(([key, data], index) => (
                    <StatProgressBar
                        key={key}
                        label={getStatLabel(key)}
                        value={data.percent}
                        count={data.count}
                        total={data.total}
                        color={colors[index % colors.length]}
                    />
                ))}
            </CardContent>
        </Card>
    );
};

export const getStatLabel = (key) => {
    const labels = {
        nonCostitiusce: "Non costituisce persona politicamente esposta",
        nonRiveste: "Non riveste lo status di PPE da più di un anno",
        costituisce: "Costituisce persona politicamente esposta",
        nonSignificativo: "Non significativo",
        pocoSignificativo: "Poco significativo",
        abbastanzaSignificativo: "Abbastanza significativo",
        moltoSignificativo: "Molto significativo",
        senzaZona: "Senza zona geografica",
        registrate: "Valutazioni rischio effettivo registrate",
        nonRegistrate: "Valutazioni rischio effettivo non registrate"
    };
    return labels[key] || key;
};

export const RISK_COLORS = ['#91d250', '#F1DA21', '#febf00', '#ff5c5f'];
export const GENERAL_COLORS = ['#91d250', '#F1DA21', '#febf00', '#ff5c5f'];